// Constants used as keys for localStorage items
export const USER_PAYMENT_SELECTION = 'userPaymentSelection';
export const CURRENT_LNG = 'currentLng';
export const COUNTRY_CODE = 'countryCode'; // Seb Every Pay selected country code for payment methods list.
export const PATH_AFTER_PAYMENT_RESULT = 'pathAfterPaymentResult';